import { SET_ITEM_HIDDEN } from '../actions'

const initialState = {}

export default (state = initialState, action) => {
    switch (action.type) {
    case SET_ITEM_HIDDEN:
        const existingKeys = state[action.payload.customerId] ? state[action.payload.customerId] : []
        return {
            ...state,
            [action.payload.customerId]: [...existingKeys, action.payload.itemKey]
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./resources/js/redux/reducers/displayReducer.js